import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const beefCutsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'beefCuts/update':
            return {
                ...state,
                ...action.payload
            };

        case 'beefCuts/clear':
            return initialState;

        default:
            return state;
    }
};

export default beefCutsReducer;